import React from "react";
import { PageLoaderNew } from "../../atoms/Loader";

const ActivityIndicator = ({ loaderText }) => (
  <PageLoaderNew>
    <div className="spinner--wv-star">
      <div className="double-bounce1"></div>
      <div className="double-bounce2"></div>
    </div>
    <span className="loader_text">{loaderText}</span>
  </PageLoaderNew>
);

export default ActivityIndicator;